export default [
  {
    title: 'Dashboard',
    children: [
      {
        title: 'Dashboard cobrança',
        route: { path: '/dashboards-cobrancas' },
        icon: '',
        resource: 'dashboardcobranca',
        action: 'read',
      },
      {
        title: 'Dashboard comercial',
        route: { path: '/dashboards-comercial' },
        icon: '',
        resource: 'dashboardcomercial',
        action: 'read',
      },
    ],
  }, {
    title: 'Cadastros',
    children: [
      {
        title: 'Certificados',
        route: { path: '/certificados/visualizar' },
        icon: '',
        resource: 'certificado',
        action: 'read',
      },
      {
        title: 'Departamentos',
        route: { path: '/departamentos/visualizar' },
        icon: '',
        resource: 'departamento',
        action: 'read',
      },
      {
        title: 'Empresas',
        route: { path: '/empresas/visualizar' },
        icon: '',
        resource: 'empresa',
        action: 'read',
      },
      {
        title: 'Equipes',
        route: { path: '/equipes/visualizar' },
        icon: '',
        resource: 'equipe',
        action: 'read',
      },
      {
        title: 'Funções',
        route: { path: '/funcoes/visualizar' },
        icon: '',
        resource: 'funcao',
        action: 'read',
      },
      {
        title: 'Grupos Empresariais',
        route: { path: '/grupo-empresarial/visualizar' },
        icon: '',
        resource: 'gruposempresariais',
        action: 'read',
      },
      {
        title: 'Indicações',
        route: { path: '/indicacoes/visualizar' },
        icon: '',
        resource: 'indicacao',
        action: 'read',
      },
      {
        title: 'Pacotes',
        route: { path: '/pacote-servicos/visualizar' },
        icon: '',
        resource: 'pacoteservico',
        action: 'read',
      },
      {
        title: 'Pessoas',
        route: { path: '/pessoas/visualizar' },
        icon: '',
        resource: 'pessoa',
        action: 'read',
      },
      {
        title: 'Serviços',
        route: { path: '/servicos/visualizar' },
        icon: '',
        resource: 'servico',
        action: 'read',
      },
      {
        title: 'Tipos de atividade',
        route: { path: '/tipo-atividade/visualizar' },
        icon: '',
        resource: 'atividade',
        action: 'read',
      },
      {
        title: 'Tipos de tributação',
        route: { path: '/tipo-tributacao/visualizar' },
        icon: '',
        resource: 'tributacao',
        action: 'read',
      },
      {
        title: 'Alvarás',
        route: { path: '/alvaras/visualizar' },
        icon: '',
        resource: 'alvara',
        action: 'read',
      },
    ],
  }, {
    title: 'Usuários',
    icon: '',
    root: true,
    children: [
      {
        title: 'Usuários Externos',
        route: { path: '/usuarios-externos/visualizar' },
        icon: '',
        resource: 'usuexterno',
        action: 'read',
      },
      {
        title: 'Usuários Internos',
        route: { path: '/usuarios-internos/visualizar' },
        icon: '',
        resource: 'usuinterno',
        action: 'read',
      },
    ],
  }, {
    title: 'Gestão de propostas comerciais',
    children: [
      {
        title: 'Painel de propostas',
        route: { name: 'painel-proposta' },
        icon: '',
        resource: 'painelproposta',
        action: 'read',
      },
    ],
  }, {
    title: 'Parametrizações',
    children: [
      {
        title: 'Checklist',
        route: { path: '/checklists-honorarios/visualizar' },
        icon: '',
        resource: 'parametrizacaochecklist',
        action: 'read',
      },
      {
        title: 'Gerais',
        route: { name: 'parametrizacaogeral' },
        icon: '',
        resource: 'parametrizacaogeral',
        action: 'read',
      },
      {
        title: 'Controle de vencimento',
        route: { name: 'controlevencimento' },
        icon: '',
        resource: 'controlevencimento',
        action: 'read',
      },

    ],
  },
  {
    title: 'Templates',
    children: [
      {
        title: 'Contratos',
        route: { name: 'template' },
        icon: '',
        resource: 'template',
        action: 'read',
      },
      {
        title: 'E-mails',
        route: { path: '/template-email/visualizar' },
        icon: '',
        resource: 'templateemail',
        action: 'read',
      },
    ],
  },
  {
    title: 'Cobrança de documentos',
    children: [
      {
        title: 'Documentos',
        route: { path: '/documentos/visualizar' },
        icon: '',
        resource: 'documento',
        action: 'read',
      },
      {
        title: 'Modelos',
        route: { path: '/modelos/visualizar' },
        icon: '',
        resource: 'modelo',
        action: 'read',
      },
      {
        title: 'Portal de documentos',
        route: { name: 'portaldocumentos-inerno' },
        icon: '',
        resource: 'portaldocumentosinterno',
        action: 'read',
      },
    ],
  }, {
    title: 'Permissões',
    children: [
      {
        title: 'Grupos de usuários',
        route: { path: '/grupo-usuario/visualizar' },
        icon: '',
        resource: 'grupo',
        action: 'read',
      },
    ],
  },
  {
    title: 'Configurações',
    children: [
      {
        title: 'notificações',
        route: { name: 'notificacoes' },
        icon: '',
        resource: 'notificacoes',
        action: 'read',
      },
      {
        title: 'E-mails',
        route: { name: 'emailconfig' },
        icon: '',
        resource: 'email',
        action: 'read',
      },
      {
        title: 'Proprietários',
        route: { name: 'proprietario' },
        icon: '',
        resource: 'proprietario',
        action: 'read',
      },
      {
        title: 'API',
        route: { name: 'configuracaoapi' },
        icon: '',
        resource: 'configuracaoapi',
        action: 'read',
      },
      {
        title: 'Webhooks',
        route: { name: 'webhooks' },
        icon: '',
        resource: 'webhooks',
        action: 'read',
      },
    ],
  },
  {
    title: 'Segurança',
    children: [
      {
        title: 'Log geral',
        route: { name: 'log' },
        icon: '',
        resource: 'log',
        action: 'read',
      },
    ],
  },
]
